// Paid Quiz2, Google-source and campaign rollouts plus active consent cohorts.
// Routing never grants advertising consent or entitlement.
// Keep in sync with Quiz2's lib/paywall/handoff.ts.
const PAID_QUIZ2_FUNNELS = [
  'seasonal-color-analysis', 'hairstyle-analysis', 'hair-color-analysis',
  'bodytype', 'face-shape-analysis', 'hairstyle-analysis-199c',
];
const THANK_YOU_CAMPAIGNS = [
  'ColorType_060726_US_DSP_[Winners]_hairstyle',
  'ColorType_191026_EU_DSP_[Winners]_hairstyle',
];
const THANK_YOU_URL = 'https://quiz2.color-analysis.pro/thank-you';

export function getPostPurchaseRedirect(fallback, search = '') {
  const thankYouUrl = process.env.REACT_APP_PAYMENT_DEPLOY_ENV === 'staging'
    ? 'https://staging-quiz.color-analysis.pro/thank-you'
    : THANK_YOU_URL;
  // The consent runtime validates campaign and any applicable country gate. Keep
  // unresolved participants on our own page too, so denial cannot be lost.
  if (typeof window !== 'undefined' && window.caConsent?.active === true) {
    return thankYouUrl;
  }
  const params = new URLSearchParams(search);
  const quiz2Funnels = params.getAll('quiz2_funnel');
  if (quiz2Funnels.length === 1 && PAID_QUIZ2_FUNNELS.includes(quiz2Funnels[0])) {
    return thankYouUrl;
  }
  const sources = params.getAll('utm_source');
  if (sources.length === 1 && (sources[0] === 'google' || sources[0] === 'Google')) {
    return thankYouUrl;
  }
  const campaigns = params.getAll('utm_campaign');
  return campaigns.length === 1 && THANK_YOU_CAMPAIGNS.includes(campaigns[0])
    ? thankYouUrl
    : fallback;
}
